import * as React from 'react';
import { useState } from 'react';
import { Address } from './Address';

export const AddressContext = React.createContext({
    addresses: [],
    selected: null,
    total: null,
    page: 1,
    perPage: 10,
    setPerPage: (any)=>{any},
    setPage: (any)=>{any},
    setAddresses: (any)=>{any},
    setSelected: (any)=>{any},
    setTotal: (any)=>{any},
});

export const useContext = () => {

    const [addresses, setAdresses] = useState([] as Address[]);
    const [selected, setSelected] = useState(getNewAddress());

    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(2);
    const [total, setTotal] = useState(0);  

    const contextValue = {
        addresses: addresses,
        setAddresses: setAdresses,
        selected: selected,
        setSelected: setSelected,
        total: total,
        perPage: perPage, 
        setPerPage: setPerPage,
        page: page, 
        setPage: setPage,
        setTotal: setTotal
    };

    return contextValue;
}

export const getNewAddress = ()=> {
    let address: Address = {
        id: '',
        first_name: '',
        last_name: '',
        company: '',
        street_address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        phone: '',
        mobile: '',
        email: '',
        default_billing: false,
        default_shipping: false
    }
    return address;
}